import { OwnerConfigEntity } from "./types";
import { DeepPartial } from "utility-types";
import { deepMerge } from "utilities/deepMerge";

export function configMerger(
  ...customConfigs: DeepPartial<OwnerConfigEntity>[]
): OwnerConfigEntity {
  return deepMerge(...customConfigs) as OwnerConfigEntity;
}
